<!-- Slideout setting section -->
<cv-module-custom-setting-section *ngIf="moduleManager.settingsView === 'slideout'" [moduleManager]="moduleManager">
    <div class="custom-setting-section-title" cvLocalizedText langSection="Calibration_Widgets" langKey="Variance_Threshold">Variance Threshold</div>
    <div class="custom-setting-section-body">
        <div class="container">
            <div class="row">
                <div class="mt-2 mr-2" cvLocalizedText langSection="Calibration_Widgets" langKey="Variance_Scale_Text">Show as Red above (absolute value)</div>
                <cxone-numeric-selector
                    [(ngModel)]="varianceScaleValue"
                    [step]="1"
                    [min]="0"
                    [max]="100">
                </cxone-numeric-selector>
                <div class="mt-2 ml-2">%</div>
            </div>
        </div>
    </div>
</cv-module-custom-setting-section>
<ng-container *ngIf="moduleManager.settingsView === 'modal'">
    <div cvModuleLegacyCustomSettingSection position="top" [moduleManager]="moduleManager">
        <div cvLocalizedText langSection="Calibration_Widgets" langKey="Variance_Threshold">Variance Threshold</div>
        <div class="container">
            <div class="row">
                <div class="mt-2 mr-2" cvLocalizedText langSection="Calibration_Widgets" langKey="Variance_Scale_Text">Show as Red above (absolute value)</div>
                <cxone-numeric-selector
                    [(ngModel)]="varianceScaleValue"
                    [step]="1"
                    [min]="0"
                    [max]="100">
                </cxone-numeric-selector>
                <div class="mt-2 ml-2">%</div>
            </div>
        </div>
    </div>
</ng-container>
<ng-container *ngIf="moduleManager.settingsView === 'cxOneModal'">
    <div class="form-group" cvModuleCxoneCustomSettingSection position="top" [moduleManager]="moduleManager">
        <div class="cxone-section-header" cvLocalizedText langSection="Calibration_Widgets" langKey="Variance_Threshold">Variance Threshold</div>
        <div class="container">
            <div class="row">
                <div class="mt-2 mr-2" cvLocalizedText langSection="Calibration_Widgets" langKey="Variance_Scale_Text">Show as Red above (absolute value)</div>
                <cxone-numeric-selector
                    [(ngModel)]="varianceScaleValue"
                    [step]="1"
                    [min]="0"
                    [max]="100">
                </cxone-numeric-selector>
                <div class="mt-2 ml-2">%</div>
            </div>
        </div>
    </div>
    <!-- Evaluator Calibration Additional Filters -->
    <div class="form-group" cvModuleCxoneCustomSettingSection after="emp" [moduleManager]="moduleManager">
        <p class="cxone-section-header" cvLocalizedText langSection="CXOne_Modal" langKey="Additional_Filters">Additional Filters</p>
        <cv-reportingset-dynamic-filters-wrapper [moduleManager]="moduleManager" [reportingSetDefinitions]="['Calibration Fact Evaluator Summary']"></cv-reportingset-dynamic-filters-wrapper>
    </div>
</ng-container>
